type ChangeToUniqueArray = (originArray: string[]) => string[] | undefined;
export const changeToUniqueArray: ChangeToUniqueArray = (originArray) => {
  const uniqueValueArray = Array.from(new Set(originArray)).filter(Boolean);
  if (uniqueValueArray.length === 0) return undefined;
  return uniqueValueArray;
};
